import { isShowEvent } from 'src/config/event/utils';
import { SampleGptButton } from '../SampleGptButton';
import { GPTGameLauncher } from 'src/EXPERIMENTAL_LIB/gpt/games';
import { useModalContext } from 'src/hooks/useModalContext';
import { VendingMachineEventIcon } from 'src/config/assets/gptEventIcons/VendingMachineEventIcon';

export const VendingMachineButton = () => {
  const { openModal } = useModalContext();

  const handleRegistration = () => {
    openModal('SIGNUP', { props: { hideWhyNot: true } });
  };

  return (
    <GPTGameLauncher
      gameName="vendingMachine"
      renderButton={({ Icon, ...props }) => (
        <SampleGptButton
          Icon={isShowEvent('GPT_GAMES') ? VendingMachineEventIcon : Icon}
          {...props}
        />
      )}
      openRegistration={handleRegistration}
    />
  );
};
